var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareControlIcon = function SvgCompareControlIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.5 11.25c0-.935 0-1.402.201-1.75a1.5 1.5 0 0 1 .549-.549c.348-.201.815-.201 1.75-.201h2c.935 0 1.402 0 1.75.201a1.5 1.5 0 0 1 .549.549c.201.348.201.815.201 1.75s0 1.402-.201 1.75a1.5 1.5 0 0 1-.549.549c-.348.201-.815.201-1.75.201H9c-.935 0-1.402 0-1.75-.201A1.5 1.5 0 0 1 6.701 13c-.201-.348-.201-.815-.201-1.75ZM12 8.25a2 2 0 1 0-4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10 10.75v1"
  })));
};
export default SvgCompareControlIcon;